import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'update_record_' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  outputKey: keyAuto(),
  columns: [],
  updateMethod: 'update_by_record_id',
  targetDatabaseId: null,
  databaseList: [],
  recordId: '',
});

const onLoadData = (rawData) => {
  const data = { ...initData(), ...rawData };
  // v1 compat: key → outputKey
  if (rawData.key && !rawData.outputKey) {
    data.outputKey = rawData.key;
    delete data.key;
  }
  // v1 compat: id → recordId
  if (rawData.id !== undefined && rawData.recordId === undefined) {
    data.recordId = rawData.id;
    delete data.id;
  }
  // v1 compat: checked → enabled within columns
  if (Array.isArray(data.columns)) {
    data.columns = data.columns.map((col) => {
      if (col.checked !== undefined && col.enabled === undefined) {
        const { checked, ...rest } = col;
        return { ...rest, enabled: checked };
      }
      return col;
    });
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'update_database_record',
  endpoint: 'update_database_record',
  registryKey: 'update_database_record',
  initData,
  onLoadData,

  extraState: () => ({
    placeholders: [],
    position: null,
    focus: null,
  }),

  extraActions: (set, get) => ({
    // Backward-compat alias used by prefillComponentStores
    setUpdateDatabaseRecordTemplate: (component) => {
      get().setComponentData(component);
    },

    setData: (columns) =>
      set((s) => ({ data: { ...s.data, columns } })),

    clearData: () =>
      set((s) => ({ data: { ...s.data, columns: [] } })),

    setDatabaseList: (databaseList) =>
      set((s) => ({ data: { ...s.data, databaseList } })),

    setTargetDatabaseId: (targetDatabaseId) =>
      set((s) => ({ data: { ...s.data, targetDatabaseId } })),

    setPlaceholders: (placeholders) => set({ placeholders }),

    setChecked: (value, index) => {
      set((s) => {
        const columns = s.data.columns.map((col, i) =>
          i === index ? { ...col, enabled: value } : col
        );
        return { data: { ...s.data, columns } };
      });
    },

    selectAll: () => {
      set((s) => {
        const allChecked = s.data.columns.every((cell) => cell.enabled);
        const columns = s.data.columns.map((cell) => ({ ...cell, enabled: !allChecked }));
        return { data: { ...s.data, columns } };
      });
    },

    setFocus: (index, focus) => {
      set({ position: index, focus, placeholders: [] });
    },

    setUpdateMethod: (value) =>
      set((s) => ({ data: { ...s.data, updateMethod: value } })),

    setPlaceholderKey: (value) =>
      set((s) => ({ data: { ...s.data, outputKey: value } })),

    setId: (value) =>
      set((s) => ({ data: { ...s.data, recordId: value } })),

    deleteId: () =>
      set((s) => ({ data: { ...s.data, recordId: '' } })),

    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
        placeholders: s.placeholders,
        position: s.position,
        focus: s.focus,
      };
    },
  }),
});

export { createStore as createUpdateDatabaseRecordStore };
export const getUpdateDatabaseRecordStore = getStore;
export default defaultStore;
